import { Image } from '@volkswagen-onehub/components-core';
import styled from 'styled-components';

export const VehicleCard = styled.div<{ isActive: boolean; hasError: boolean }>`
	background: ${({ isActive }) => (isActive ? '#ffffff' : 'transparent')};
	border-radius: 8px;
	border: 2px solid ${({ isActive, hasError }) => (isActive ? '#997F67' : hasError ? '#e4002c' : 'transparent')};
	cursor: pointer;
	container: vehicle-card / inline-size;

	display: flex;
	flex-direction: column;
	justify-content: center;

	width: 100%;
	height: 100%;

	padding-top: 8px;
	padding-bottom: 8px;
`;

export const VehicleCardImageContainer = styled.div`
	width: 100%;
	height: clamp(60px, 60cqw, 180px);
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	background: transparent;
`;

export const VehicleCardImage = styled(Image)`
	display: block;
	width: 100%;
	height: 100%;
	object-fit: contain;
	object-position: center;
`;
